import { SHEET_FONT } from './aiPaperUtils';

// 186mm printable width (A4 210mm - 2 x 12mm margins) at 96dpi
export const SHEET_W = 703;
export const FONT_LINK = 'https://fonts.googleapis.com/css2?family=Noto+Serif+Devanagari:wght@400;600;700&family=Noto+Serif:wght@400;600;700&display=swap';

// Single CSS source used by the on-screen sheet AND the print window.
export const SHEET_CSS = `
@page { size: A4 portrait; margin: 12mm; }
.aip-sheet { width: ${SHEET_W}px; background: #fff; color: #000; font-family: ${SHEET_FONT}; font-size: 13.5px; line-height: 1.45; font-style: normal; box-sizing: border-box; }
.aip-sheet * { box-sizing: border-box; font-style: normal; }
.aip-block { break-inside: avoid; page-break-inside: avoid; }
.aip-head { text-align: center; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 8px; }
.aip-head-row { display: flex; align-items: center; justify-content: center; gap: 14px; }
.aip-head img { width: 62px; height: 62px; object-fit: contain; }
.aip-school { font-size: 26px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; margin: 0; }
.aip-tag { font-size: 12px; margin-top: 2px; }
.aip-banner { text-align: center; font-weight: 700; font-size: 15px; text-transform: uppercase; letter-spacing: .5px; margin: 6px 0; }
.aip-conf { text-align: center; font-weight: 700; font-size: 13px; border: 2px solid #000; padding: 4px; margin: 6px 0; letter-spacing: 1px; }
.aip-grid { display: grid; grid-template-columns: 1fr 1fr; border: 1px solid #000; margin-bottom: 8px; }
.aip-grid div { padding: 4px 8px; border: 1px solid #000; margin: -0.5px; font-size: 13px; }
.aip-instr { font-size: 12.5px; margin-bottom: 8px; }
.aip-instr ol { margin: 3px 0 0 18px; padding: 0; }
.aip-sec { text-align: center; font-weight: 700; font-size: 14px; border-top: 1.5px solid #000; border-bottom: 1.5px solid #000; padding: 4px 0; margin: 12px 0 4px; text-transform: uppercase; }
.aip-attempt { text-align: center; font-size: 12.5px; font-weight: 600; margin-bottom: 6px; }
.aip-q { display: flex; gap: 8px; margin: 7px 0; }
.aip-qn { min-width: 26px; font-weight: 700; }
.aip-qb { flex: 1; min-width: 0; }
.aip-qm { min-width: 34px; text-align: right; font-weight: 700; white-space: nowrap; }
.aip-en { white-space: pre-wrap; }
.aip-hi { white-space: pre-wrap; margin-top: 2px; }
.aip-opts { display: grid; grid-template-columns: 1fr 1fr; gap: 3px 16px; margin-top: 4px; }
.aip-ans { margin-top: 4px; padding: 4px 8px; border-left: 3px solid #000; background: #f2f2f2; font-size: 12.5px; white-space: pre-wrap; }
.aip-ref { font-size: 11.5px; margin-top: 2px; }
.aip-foot { text-align: center; font-weight: 700; margin-top: 14px; letter-spacing: 1px; }
`;
